export default "__VITE_ASSET__Fx2meril__"